/* eslint-disable */
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardTitle from "@saleor/components/CardTitle";
import Typography from "@material-ui/core/Typography";
import {
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  IconButton,
  Button
} from "@material-ui/core";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import DeleteIcon from "@material-ui/icons/Delete";

import Grid from "@saleor/components/Grid";
import { sectionNames } from "@saleor/intl";
import { maybe, renderCollection } from "@saleor/misc";
import { Popup_loginpopup_edges_node } from "@saleor/popup/types/Popup";
import { LoginPopupPopupTypeEnum } from "@saleor/types/globalTypes";
import React from "react";
import Skeleton from "@saleor/components/Skeleton";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";

import TextField from "@material-ui/core/TextField";
import FormSpacer from "@saleor/components/FormSpacer";
import SingleSelectField from "@saleor/components/SingleSelectField";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import S3TextField from "@saleor/components/S3TextField";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import { FormattedMessage, useIntl } from "react-intl";
import CardSpacer from "@saleor/components/CardSpacer";

export interface PopupDetailPageProps {
  popup: Popup_loginpopup_edges_node | null;
  disabled: boolean;
  onSubmit: (data: PopupFormData) => void;
  onBack: () => void;
  saveButtonBarState: ConfirmButtonTransitionState;
  onRowClick: (id: string) => () => void;
  onDeleteVoucher: (code: string) => void;
  onAddVoucher: () => void;
  defaultCreate: () => void;
}
export interface PopupFormData {
  title: string;
  coupon: string;
  Button: string;
  pcUrl: string;
  mbUrl: string;
  pcThumbnail: string;
  mbThumbnail: string;
  couponCode: string[];
  couponValue: number;
  buttonValue: number;
  popupType: LoginPopupPopupTypeEnum;
  subTitle: string;
  isEnable: boolean;
  isAffUse: boolean;
  textColor: string;
  buttonTextColor: string;
  buttonBackgroudColor: string;
  buttonBorderColor: string;

  pcSuccessful: string;
  mbSuccessful: string;
  successfulLink: string;
  pcSuccessfulLinkTarget: string;
  mbSuccessfulLinkTarget: string;
  popupUpMinutes: number | null;
}
const PopupDetailPage: React.FC<PopupDetailPageProps> = ({
  popup,
  disabled,
  onSubmit,
  onBack,
  saveButtonBarState,
  onRowClick,
  onDeleteVoucher,
  onAddVoucher,
  defaultCreate
}) => {
  const initialForm: PopupFormData =
    popup === null
      ? {
          title: "",
          coupon: "",
          Button: "",
          pcUrl: "",
          mbUrl: "",
          pcThumbnail: "",
          mbThumbnail: "",
          couponCode: [""],
          couponValue: 0,
          buttonValue: 0,
          popupType: LoginPopupPopupTypeEnum.OLD,
          subTitle: "",
          isEnable: false,
          isAffUse: true,
          textColor: "",
          buttonTextColor: "",
          buttonBackgroudColor: "",
          buttonBorderColor: "",
          pcSuccessful: "",
          mbSuccessful: "",
          successfulLink: "",
          pcSuccessfulLinkTarget: "",
          mbSuccessfulLinkTarget: "",
          popupUpMinutes: null
        }
      : {
          title: maybe(() => popup.title, ""),
          coupon: maybe(() => popup.coupon, ""),
          Button: maybe(() => popup.Button, ""),
          pcUrl: maybe(() => popup.pcUrl, ""),
          mbUrl: maybe(() => popup.mbUrl, ""),
          pcThumbnail: maybe(() => popup.pcThumbnail, ""),
          mbThumbnail: maybe(() => popup.mbThumbnail, ""),
          couponCode: maybe(() => popup.couponCodes, [""]),
          couponValue: maybe(() => popup.couponValue, 0),
          buttonValue: maybe(() => popup.buttonValue, 0),
          popupType: maybe(
            () => (popup.popupType as unknown) as LoginPopupPopupTypeEnum,
            LoginPopupPopupTypeEnum.OLD
          ),
          subTitle: maybe(() => popup.subTitle, ""),
          isEnable: maybe(() => popup.isEnable, false),
          isAffUse: maybe(() => popup.isAffUse, true),
          textColor: maybe(() => popup.textColor, ""),
          buttonTextColor: maybe(() => popup.buttonTextColor, ""),
          buttonBackgroudColor: maybe(() => popup.buttonBackgroudColor, ""),
          buttonBorderColor: maybe(() => popup.buttonBorderColor, ""),
          pcSuccessful: maybe(() => popup.pcSuccessful, ""),
          mbSuccessful: maybe(() => popup.mbSuccessful, ""),
          successfulLink: maybe(() => popup.successfulLink, ""),
          pcSuccessfulLinkTarget: maybe(() => popup.pcSuccessfulLinkTarget, ""),
          mbSuccessfulLinkTarget: maybe(() => popup.mbSuccessfulLinkTarget, ""),
          popupUpMinutes: maybe(() => popup.popupUpMinutes, null)
        };
  const intl = useIntl();
  const inputTypeChoices = [
    {
      label: intl.formatMessage({
        defaultMessage: "Old Template",
        description: "旧模板"
      }),
      value: LoginPopupPopupTypeEnum.OLD
    },
    {
      label: intl.formatMessage({
        defaultMessage: "New Template",
        description: "新模板"
      }),
      value: LoginPopupPopupTypeEnum.NEW
    }
  ];

  const TargetChoices = [
    {
      label: intl.formatMessage({
        defaultMessage: "current window",
        description: "link target for choice"
      }),
      value: "_self"
    },
    {
      label: intl.formatMessage({
        defaultMessage: "new blank tab",
        description: "link target for choice"
      }),
      value: "_blank"
    }
  ];

  return (
    <>
      <Form initial={initialForm} onSubmit={onSubmit}>
        {({ change, data, hasChanged, setNameValue, submit }) => (
          <Container>
            <AppHeader onBack={onBack}>
              {intl.formatMessage(sectionNames.configuration)}
            </AppHeader>
            <Grid>
              {popup ? (
                <>
                  <div>
                    <Card>
                      <CardTitle
                        title={intl.formatMessage({
                          defaultMessage: "Loging Popup"
                        })}
                      />
                      <CardContent>
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup Title",
                            description: "Title"
                          })}
                          name={"title" as keyof PopupFormData}
                          fullWidth
                          value={data.title}
                          onChange={change}
                        />
                        <FormSpacer />
                        <ControlledCheckbox
                          name={"isEnable" as keyof PopupFormData}
                          label={intl.formatMessage({
                            defaultMessage: "IS Enable",
                            description: "isEnable"
                          })}
                          checked={data.isEnable}
                          onChange={change}
                          disabled={disabled}
                        />
                        <FormSpacer />
                        <ControlledCheckbox
                          name={"isAffUse" as keyof PopupFormData}
                          label={intl.formatMessage({
                            defaultMessage: "Show to Aff URL Customer",
                            description: "isAffUse"
                          })}
                          checked={data.isAffUse}
                          onChange={change}
                          disabled={disabled}
                        />
                        <FormSpacer />
                        <SingleSelectField
                          choices={inputTypeChoices}
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup Type",
                            description: "popupType"
                          })}
                          name={"popupType" as keyof PopupFormData}
                          onChange={change}
                          value={data.popupType}
                        />
                        <FormSpacer />
                        {data.popupType === LoginPopupPopupTypeEnum.NEW && (
                          <TextField
                            disabled={disabled}
                            label={intl.formatMessage({
                              defaultMessage: "Popup SubTitle",
                              description: "subTitle"
                            })}
                            name={"subTitle" as keyof PopupFormData}
                            fullWidth
                            value={data.subTitle}
                            onChange={change}
                          />
                        )}
                        <FormSpacer />

                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Coupon Text",
                            description: "coupon"
                          })}
                          name={"coupon" as keyof PopupFormData}
                          fullWidth
                          helperText={intl.formatMessage({
                            defaultMessage:
                              "You can use $fixedValue to indicate the preferential fixed value."
                          })}
                          value={data.coupon}
                          onChange={change}
                        />
                        <FormSpacer />

                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Text Color",
                            description: "Text Color"
                          })}
                          name={"textColor" as keyof PopupFormData}
                          fullWidth
                          helperText={intl.formatMessage({
                            defaultMessage: "Text Color."
                          })}
                          value={data.textColor}
                          onChange={change}
                        />
                        <FormSpacer />

                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Button Text",
                            description: "Button"
                          })}
                          name={"Button" as keyof PopupFormData}
                          fullWidth
                          helperText={intl.formatMessage({
                            defaultMessage:
                              "You can use $fixedValue to indicate the preferential fixed value."
                          })}
                          value={data.Button}
                          onChange={change}
                        />
                        <FormSpacer />

                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Button Text Color",
                            description: "Button Text Color"
                          })}
                          name={"buttonTextColor" as keyof PopupFormData}
                          fullWidth
                          helperText={intl.formatMessage({
                            defaultMessage: "Button Text Color."
                          })}
                          value={data.buttonTextColor}
                          onChange={change}
                        />
                        <FormSpacer />

                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Button Backgroud Color",
                            description: "Button Backgroud Color"
                          })}
                          name={"buttonBackgroudColor" as keyof PopupFormData}
                          fullWidth
                          helperText={intl.formatMessage({
                            defaultMessage: "Button Backgroud Color."
                          })}
                          value={data.buttonBackgroudColor}
                          onChange={change}
                        />
                        <FormSpacer />

                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Button Border Color",
                            description: "Button Border Color"
                          })}
                          name={"buttonBorderColor" as keyof PopupFormData}
                          fullWidth
                          helperText={intl.formatMessage({
                            defaultMessage: "Button Border Color."
                          })}
                          value={data.buttonBorderColor}
                          onChange={change}
                        />
                        <FormSpacer />

                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup Coupon Value",
                            description: "couponValue"
                          })}
                          fullWidth
                          name={"couponValue" as keyof PopupFormData}
                          value={data.couponValue}
                          onChange={change}
                        />
                        <FormSpacer />
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup Button Value",
                            description: "buttonValue"
                          })}
                          fullWidth
                          name={"buttonValue" as keyof PopupFormData}
                          value={data.buttonValue}
                          onChange={change}
                        />
                        <FormSpacer />
                        {/* <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup PC Url",
                            description: "pcUrl"
                          })}
                          name={"pcUrl" as keyof PopupFormData}
                          fullWidth
                          value={data.pcUrl}
                          onChange={change}
                        /> */}
                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup PC Url",
                            description: "pcUrl"
                          })}
                          name={"pcUrl"}
                          value={data.pcUrl}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                        <FormSpacer />
                        {/* <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup MB Url",
                            description: "mbUrl"
                          })}
                          name={"mbUrl" as keyof PopupFormData}
                          fullWidth
                          value={data.mbUrl}
                          onChange={change}
                        /> */}
                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup MB Url",
                            description: "mbUrl"
                          })}
                          name={"mbUrl"}
                          value={data.mbUrl}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                        <FormSpacer />
                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup pc Thumbnail Url",
                            description: "pcThumbnail"
                          })}
                          name={"pcThumbnail"}
                          value={data.pcThumbnail}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                        <FormSpacer />
                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup mb Thumbnail Url",
                            description: "mbThumbnail"
                          })}
                          name={"mbThumbnail"}
                          value={data.mbThumbnail}
                          onChange={change}
                          setNameValue={setNameValue}
                        />

                        <FormSpacer />
                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Registration successful img (PC)",
                            description: "pcSuccessful"
                          })}
                          name={"pcSuccessful"}
                          value={data.pcSuccessful}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                        <FormSpacer />
                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage:
                              "Registration successful img (Mobile)",
                            description: "mbSuccessful"
                          })}
                          name={"mbSuccessful"}
                          value={data.mbSuccessful}
                          onChange={change}
                          setNameValue={setNameValue}
                        />

                        <FormSpacer />
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Registration successful Link",
                            description: "successfulLink"
                          })}
                          fullWidth
                          name={"successfulLink" as keyof PopupFormData}
                          value={data.successfulLink}
                          onChange={change}
                        />
                        <FormSpacer />

                        <SingleSelectField
                          disabled={disabled}
                          choices={TargetChoices}
                          label={intl.formatMessage({
                            defaultMessage:
                              "Registration successful Open the link (PC)",
                            description: "pcSuccessfulLinkTarget"
                          })}
                          name={"pcSuccessfulLinkTarget" as keyof PopupFormData}
                          onChange={change}
                          value={data.pcSuccessfulLinkTarget}
                        />

                        <FormSpacer />

                        <SingleSelectField
                          disabled={disabled}
                          choices={TargetChoices}
                          label={intl.formatMessage({
                            defaultMessage:
                              "Registration successful Open the link (Mobile)",
                            description: "mbSuccessfulLinkTarget."
                          })}
                          name={"mbSuccessfulLinkTarget" as keyof PopupFormData}
                          onChange={change}
                          value={data.mbSuccessfulLinkTarget}
                        />

                        <FormSpacer />

                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Set pop-up Time(minutes)",
                            description: "popupUpMinutes"
                          })}
                          fullWidth
                          name={"popupUpMinutes" as keyof PopupFormData}
                          value={
                            data.popupUpMinutes == null
                              ? ""
                              : data.popupUpMinutes
                          }
                          // onChange={change}
                          onChange={e => {
                            const v = (e.target as HTMLInputElement).value;
                            setNameValue(
                              "popupUpMinutes",
                              v === "" ? null : Number(v)
                            );
                          }}
                        />
                      </CardContent>
                    </Card>
                    <CardSpacer />
                    <Card>
                      <CardTitle
                        title={intl.formatMessage({
                          defaultMessage: "Popup Vouchers",
                          description: "Vouchers"
                        })}
                        toolbar={
                          <Button
                            color={"primary"}
                            onClick={onAddVoucher}
                            style={{ float: "right" }}
                          >
                            <FormattedMessage
                              defaultMessage="Assign Vouchers"
                              description="button"
                            />
                          </Button>
                        }
                      />
                      <CardContent>
                        <ResponsiveTable>
                          <TableHead>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Name"
                                description="voucher name"
                              />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Code"
                                description="voucher code"
                              />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Delete"
                                description="voucher code"
                              />
                            </TableCell>
                          </TableHead>
                          <TableBody>
                            {renderCollection(popup?.vouchers, voucher => (
                              <TableRow
                                hover={!!voucher}
                                onClick={
                                  !!voucher ? onRowClick(voucher.id) : undefined
                                }
                                key={voucher ? voucher.id : "skeleton"}
                              >
                                <TableCell>
                                  {maybe<React.ReactNode>(
                                    () => voucher.name,
                                    <Skeleton />
                                  )}
                                </TableCell>
                                <TableCell>
                                  {maybe<React.ReactNode>(
                                    () => voucher.code,
                                    <Skeleton />
                                  )}
                                </TableCell>
                                <TableCell>
                                  <IconButton
                                    onClick={event => {
                                      event.stopPropagation();
                                      onDeleteVoucher(voucher.code);
                                    }}
                                  >
                                    <DeleteIcon color="primary" />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </ResponsiveTable>
                      </CardContent>
                    </Card>
                  </div>
                  <div>
                    <Card style={{ overflow: "visible" }}>
                      <CardTitle
                        title={intl.formatMessage({
                          defaultMessage: "Popup Summary"
                        })}
                      />
                      {data.isEnable ? (
                        <CardContent>
                          <Typography variant="caption">
                            <FormattedMessage
                              defaultMessage="Popup Title"
                              description="popup Title"
                            />
                          </Typography>
                          <Typography>
                            {maybe<React.ReactNode>(
                              () => data.title,
                              <Skeleton />
                            )}
                          </Typography>
                          <FormSpacer />
                          <Typography variant="caption">
                            <FormattedMessage
                              defaultMessage="Popup Type"
                              description="Popup Type"
                            />
                          </Typography>
                          <Typography>
                            {maybe<React.ReactNode>(
                              () => data.popupType,
                              <Skeleton />
                            )}
                          </Typography>
                          <FormSpacer />
                          {data.popupType === LoginPopupPopupTypeEnum.NEW && (
                            <>
                              <Typography variant="caption">
                                <FormattedMessage
                                  defaultMessage="Popup SubTitle"
                                  description="SubTitle"
                                />
                              </Typography>
                              <Typography>
                                {maybe<React.ReactNode>(
                                  () => data.subTitle,
                                  <Skeleton />
                                )}
                              </Typography>
                              <FormSpacer />
                            </>
                          )}
                          <FormSpacer />
                          <Typography variant="caption">
                            <FormattedMessage
                              defaultMessage="Popup Coupon Text"
                              description="Popup Coupon"
                            />
                          </Typography>
                          <Typography>
                            {maybe<React.ReactNode>(
                              () => popup?.couponText,
                              <Skeleton />
                            )}
                          </Typography>
                          <FormSpacer />
                          <Typography variant="caption">
                            <FormattedMessage
                              defaultMessage="Popup Button Text"
                              description="Popup Coupon"
                            />
                          </Typography>
                          <Typography>
                            {maybe<React.ReactNode>(
                              () => popup?.buttonText,
                              <Skeleton />
                            )}
                          </Typography>
                          <FormSpacer />
                          <Typography variant="caption">
                            <FormattedMessage
                              defaultMessage="Popup PC Images"
                              description="Popup PC Images"
                            />
                          </Typography>
                          <Typography>
                            <img
                              src={data.pcUrl}
                              alt=""
                              style={{ width: "350px" }}
                            />
                          </Typography>
                          <FormSpacer />
                          <Typography variant="caption">
                            <FormattedMessage
                              defaultMessage="Popup MB Images"
                              description="Popup MB Images"
                            />
                          </Typography>
                          <Typography>
                            <img
                              src={data.mbUrl}
                              alt=""
                              style={{ width: "350px" }}
                            />
                          </Typography>
                        </CardContent>
                      ) : (
                        <CardContent>
                          <Typography>
                            <FormattedMessage
                              defaultMessage="Pop up window closed!"
                              description="no popup show"
                            />
                          </Typography>
                        </CardContent>
                      )}
                    </Card>
                  </div>
                </>
              ) : (
                <Card>
                  <CardContent>
                    <Button
                      color="primary"
                      onClick={defaultCreate}
                      disabled={disabled}
                    >
                      <FormattedMessage
                        defaultMessage="Create Default"
                        description="button"
                      />
                    </Button>

                    <CardSpacer />
                    <p style={{ color: "#999", marginLeft: "20px" }}>
                      {
                        "New pop-up window has not been set, please initialize first"
                      }
                    </p>
                  </CardContent>
                </Card>
              )}
            </Grid>
            <SaveButtonBar
              disabled={disabled || !hasChanged}
              state={saveButtonBarState}
              onCancel={onBack}
              onSave={submit}
            />
          </Container>
        )}
      </Form>
    </>
  );
};
export default PopupDetailPage;
